<template>
	<o-tour
		:ref="setup._tourOrderDetailsAgency">
		<o-tour-step
			title="Détail d'une commande"
			size="lg"
			hide-finish>
			<template #actions="{ next }">
				<o-button
					size="xs"
					outline
					color="info"
					@click="setup.openDiscussion()">
					Contacter le client
				</o-button>
				<o-button
					size="xs"
					color="brand"
					@click="next">
					Suivant
				</o-button>
			</template>
			<p>
				Lorsque votre client vous adresse une commande, ou que vous en avez créé une pour son compte,
				vous accéderez à un <b>détail</b> constitué de quatre onglets.
			</p>
			<o-alert color="info">
				Astuce : Vous pouvez lancer le tuto associé à chacun des onglets en cliquant sur le lien en bleu !
			</o-alert>
			<ul>
				<li>
					Le <span
						class="tour-link"
						@click="setup.launchPipelineTourAsync()">
						suivi des candidats
					</span>, qui sera le centre névralgique de votre activité sur une commande.
				</li>
				<li>
					<span
						class="tour-link"
						@click="setup.launchCandidateTourAsync()">
						Vie de la commande
					</span> pour voir son avancée
				</li>
				<li>
					Un <b>récapitulatif</b> de la commande en question.
				</li>
				<li>
					Un <b>historique</b> complet de l'activité associée à la commande.
				</li>
			</ul>
			<o-alert color="info">
				Une commande créée <b>ne peut plus être modifiée</b> par votre client.
				<br>Si certains éléments viennent à évoluer, vous pourrez en discuter
				via le <b>chat en ligne</b> Armado !
			</o-alert>
		</o-tour-step>

		<o-tour-step
			title="Récapitulatif Revenir en arrière"
			target="order-details__back"
			hide-finish>
			Cliquez ici si vous souhaitez <b>revenir en arrière</b> et retrouver <b>la liste</b> des commandes !
		</o-tour-step>

		<o-tour-step
			title="Discuter avec l'interlocuteur"
			target="order-details__discussion"
			:hide-finish="setup.canUpdate">
			<template #actions="{ next, previous }">
				<o-button
					size="xs"
					outline
					color="info"
					@click="setup.openDiscussion()">
					Contacter le client
				</o-button>
				<o-button
					size="xs"
					outline
					@click="previous">
					Précédent
				</o-button>
				<o-button
					v-if="setup.canUpdate"
					size="xs"
					color="brand"
					@click="next">
					Suivant
				</o-button>
			</template>
			Si vous avez des <b>questions</b> à poser à votre client
			ou des <b>informations complémentaires</b> à apporter, vous pourrez lancer une nouvelle
			<b>discussion contextuelle</b> à partir de cette icône.
		</o-tour-step>

		<o-tour-step
			v-if="setup.canCancel"
			size="lg"
			title="Annuler la commande"
			target="order-details__cancel"
			hide-finish>
			<p>
				Si la commande n'a plus lieu d'être, ou que votre client souhaite <b>l'annuler</b>,
				vous pourrez cliquer sur cette icône pour mettre fin à celle-ci.
			</p>

			<o-alert color="info">
				Si des candidats ont été positionnés sur l'étape <b>Proposé au candidat</b>, ils recevront
				une alerte leurs indiquant que la mission <b>n'est plus à pourvoir</b> !
				<br>
				Votre client sera également <b>informé</b> de l'annulation de la commande.
			</o-alert>
		</o-tour-step>

		<o-tour-step
			v-if="setup.canUpdate"
			size="lg"
			title="Dupliquer une commande"
			target="order-details__copy"
			:hide-finish="setup.canValidate">
			<p>
				Une commande peut devenir <b>récurrente</b> ! <br>
				Afin de vous éviter une re-saisie complète de chacune des étapes,
				nous vous permettons de <b>dupliquer</b> une commande.
			</p>

			<p>
				Ce faisant, Armado va <b>compléter automatiquement les étapes</b> et vous positionner sur le récapitulatif
				afin de modifier certains éléments variables (tels que les dates 📅)
			</p>

			Une duplication permet également de <b>conserver des candidats</b> positionnés sur la commande initiale.
		</o-tour-step>

		<o-tour-step
			v-if="setup.canValidate"
			size="lg"
			title="Valider une commande"
			target="order-details__validate">
			<p>
				Une fois que la commande est <b>pourvue</b>, ou tout simplement au moment qui vous semblera
				opportun, vous pourrez la <b>valider</b>.
			</p>

			<p>
				Cette action a pour effet de <b>figer</b> la commande. <br>
				<b>Aucune action</b> ne pourra plus être effectuée aprés la validation.
			</p>

			<o-alert color="info">
				Si des candidats ont été positionnés sur l'étape <b>Validé</b>, ils recevront
				une alerte leurs indiquant que la mission <b>est pour eux</b> !
				<br>
				Votre client sera également <b>informé</b> de la validation de la commande.
			</o-alert>
		</o-tour-step>
	</o-tour>
</template>

<script setup lang="ts">
import TourOrderDetailsAgencySetupService from '@/setup/tour/TourOrderDetailsAgencySetupService';
const setup = new TourOrderDetailsAgencySetupService();
</script>

<style scoped lang="less">
.tour-link {
	font-weight:bold;
	cursor: pointer;
	color: var(--info);
}
</style>
